/**
 * PDP Video Benefits – Play / Pause + Sound toggle
 *
 * Data attributes used:
 *   [data-vb-video]     → the <video> element
 *   [data-vb-play-btn]  → the play/pause button
 *   [data-vb-sound-btn] → the mute/unmute button
 */
(function () {
  'use strict';

  /** @param {HTMLElement} section */
  const initSection = (section) => {
    const video = /** @type {HTMLVideoElement|null} */ (section.querySelector('[data-vb-video]'));
    if (!video) return;

    const playBtn  = /** @type {HTMLButtonElement|null} */ (section.querySelector('[data-vb-play-btn]'));
    const soundBtn = /** @type {HTMLButtonElement|null} */ (section.querySelector('[data-vb-sound-btn]'));

    // ── Play / Pause ──────────────────────────────────────────
    if (playBtn) {
      const iconPause = playBtn.querySelector('.pdp-video-benefits__play-icon--pause');
      const iconPlay  = playBtn.querySelector('.pdp-video-benefits__play-icon--play');

      /** @param {boolean} isPlaying */
      const syncPlay = (isPlaying) => {
        iconPause?.toggleAttribute('hidden', !isPlaying);
        iconPlay?.toggleAttribute('hidden', isPlaying);
        playBtn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      };

      video.addEventListener('play',  () => syncPlay(true));
      video.addEventListener('pause', () => syncPlay(false));

      playBtn.addEventListener('click', (/** @type {MouseEvent} */ e) => {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      syncPlay(!video.paused);
    }

    // ── Sound toggle ──────────────────────────────────────────
    if (soundBtn) {
      const iconOff = soundBtn.querySelector('.pdp-video-benefits__sound-icon--off');
      const iconOn  = soundBtn.querySelector('.pdp-video-benefits__sound-icon--on');

      /** @param {boolean} isMuted */
      const syncSound = (isMuted) => {
        iconOff?.toggleAttribute('hidden', !isMuted);
        iconOn?.toggleAttribute('hidden', isMuted);
        soundBtn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
      };

      soundBtn.addEventListener('click', (/** @type {MouseEvent} */ e) => {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        syncSound(video.muted);
      });

      // Video starts muted (browser autoplay policy)
      syncSound(video.muted);
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-section-id]').forEach((section) => {
      if (section.querySelector('[data-vb-play-btn], [data-vb-sound-btn]')) {
        initSection(/** @type {HTMLElement} */ (section));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
